/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { QueryImpl, MetadataImpl } from "./operations/index.js";
import { Query, Metadata } from "./operationsInterfaces/index.js";
import { AzureLogAnalyticsContext } from "./azureLogAnalyticsContext.js";
import { AzureLogAnalyticsOptionalParams } from "./models/index.js";

/** @internal */
export class AzureLogAnalytics extends AzureLogAnalyticsContext {
  /**
   * Initializes a new instance of the AzureLogAnalytics class.
   * @param options The parameter options
   */
  constructor(options?: AzureLogAnalyticsOptionalParams) {
    super(options);
    this.query = new QueryImpl(this);
    this.metadata = new MetadataImpl(this);
  }

  query: Query;
  metadata: Metadata;
}
